import {
  Container,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import AdvancedTradeChart from "./Components/AdvancedTradeChart";
import AdvancedTradeForm from "./Components/AdvancedTradeForm";
import AdvancedTradeMarket from "./Components/AdvancedTradeMarket";
import AdvancedTradeWallet from "./Components/AdvancedTradeWallet";
import TradeHistory from "pages/BasicTrade/components/TradeHistory";
import { getInvestmentMarketWithAccountBroker } from "store/slices/market/marketSlice";
import { getTradeInsertForm } from "store/slices/trade/tradeSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";

function AdvancedTrade() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdView = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileView = useIsMobileView();

  const [formKey, setFormKey] = useState(1);

  const dispatch = useDispatch();
  const { source, destination } = useParams();

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const [searchParams] = useSearchParams();
  const sideId = +searchParams.get("sideId") || 1;

  const brokerId =
    +searchParams.get("brokerId") || tradeInsertForm?.brokerId || 0;

  const basketId =
    +searchParams.get("basketId") || tradeInsertForm?.basketId || 0;

  useEffect(() => {
    if (isMobileView) {
      navigate("/trade/1/3");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileView]);

  useEffect(() => {
    dispatch(
      getTradeInsertForm({
        basketId,
        coinDestinationId: destination,
        sideId,
        coinSourceId: source,
      })
    );

    dispatch(
      getInvestmentMarketWithAccountBroker({
        brokerId,
        coinSourceId: source,
        coinDestinationId: destination,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brokerId, source, destination]);

  return (
    <Container maxWidth="100%">
      <Grid container>
        <Grid item lg={2.5} md={4}>
          <AdvancedTradeWallet />
        </Grid>

        <GridLeft item lg={6.5} md={8}>
          <AdvancedTradeChart />

          <AdvancedTradeForm key={formKey} />
        </GridLeft>

        {!isMdView && (
          <Grid item lg={3}>
            <AdvancedTradeMarket />
          </Grid>
        )}
      </Grid>

      <Grid container id="trade_history">
        <Grid item xs={12}>
          <TradeHistory
            onCancelOrder={() => {
              setFormKey((v) => v + 1);
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

const GridLeft = styled(Grid)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.modules.border}`,
  borderLeft: `1px solid ${theme.palette.modules.border}`,
}));

export default AdvancedTrade;
